export default "__VITE_ASSET__KA8mjUPA__"